import { AdvancedMarker } from "@vis.gl/react-google-maps";

import { CENTERED_MARKER_ANCHOR } from "helpers/googleMaps";

const CLUSTER_COLOR = "#FF6B35";

export default function AppMapCluster({
  position,
  count,
  label,
  onClick,
  clusterColor = CLUSTER_COLOR,
}) {
  const size = 34 + Math.min(count, 36);

  return (
    <AdvancedMarker
      position={position}
      zIndex={count}
      onClick={onClick}
      {...CENTERED_MARKER_ANCHOR}
    >
      <div
        className="tw:flex tw:items-center tw:justify-center tw:rounded-full tw:font-semibold tw:text-white tw:ring-2 tw:ring-white tw:shadow-md"
        style={{
          width: size,
          height: size,
          backgroundColor: clusterColor,
          fontSize: count > 99 ? 12 : 14,
        }}
      >
        {label}
      </div>
    </AdvancedMarker>
  );
}
